import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';

export function clearCongenereEligibilityStorage() {
	const resetCongenereEligibility =
		useCongenereEligibilityStore.getState().resetCongenereEligibility;
	resetCongenereEligibility();
}
